import React from "react";
import SimpleTemplate from "@insightfulscience/atomic-react/SimpleTemplate";
import Heading from "@insightfulscience/atomic-react/Heading";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import PageTitle from "@insightfulscience/smart-react/PageTitle";
import WithConditions from "@insightfulscience/smart-react/hocs/WithConditions";
import { useLocale } from "@insightfulscience/smart-react/i18";
import pipe from "@insightfulscience/shared-utils/fn/pipe";
import SiteLayout from "../../SiteLayout";
import ForgotPasswordForm from "../../ForgotPasswordForm";
import WithServices from "../../services";
import authService from "../../services/authService";
import { isNotAuthorized } from "../../services/authService/status";
import routes from "../../routes";
import { toReturnUrl } from "../../routing-utils";
import withErrorHandling from "../../AppError/withErrorHandling";
import WithMaintenance from "../../Maintenance/WithMaintenance";

const ForgotPasswordPage = () => {
	const [t] = useLocale("forgot-password-page");
	return (
		<SiteLayout isWrapper={false}>
			<PageTitle title={t("PAGE_TITLE")} />
			<SimpleTemplate utility={{ bgColor: "none" }}>
				<Heading Tag="h1" sx={{ fontSize: "xl", textAlign: "center" }} spacing={{ mb: 6 }}>
					{t("TITLE")}
				</Heading>
				<Paragraph sx={{ fontSize: "l", textAlign: "center" }}>{t("DESCRIPTION")}</Paragraph>
				<ForgotPasswordForm />
			</SimpleTemplate>
		</SiteLayout>
	);
};

ForgotPasswordPage.services = {
	authService,
};

ForgotPasswordPage.preConditions = [
	[isNotAuthorized, toReturnUrl(routes.myAccount)], // is user is logged in follow to returnUrl (to /account)
];

export default pipe(
	ForgotPasswordPage,
	WithConditions,
	withErrorHandling,
	WithServices,
	WithMaintenance({ level: "CUD" }),
);
